import styles from './unregistered-users-grid.module.scss';
import { useState } from 'react';
import { ValueFormatterParams } from 'ag-grid-community';
import { booleanHeader, CreateHeaders, dateHeader, HeaderSizeEnum, SecondaryButton, textHeader } from '@frontend-workspace/react-shared-lib';
// import UnregisteredUserDialog from '../unregistered-user-dialog/unregistered-user-dialog';
import { IUnregisteredUser } from '../../_models/unregistered-user';
import WebkuaTable from '../../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface UnregisteredUsersGridProps {
  unregisteredUsers: IUnregisteredUser[]
}

export function UnregisteredUsersGrid(props: UnregisteredUsersGridProps) {
  const { t } = useTranslation();
  const [unregisteredUser, setUnregisteredUser] = useState<IUnregisteredUser | undefined>(undefined);

  const openUnregisteredUserDialog = (e: any) => setUnregisteredUser(e.data);
  const closeUnregisteredUserDialog = () => setUnregisteredUser(undefined);

  const unregisteredUserRenderer = (params: ValueFormatterParams) => (
    <SecondaryButton
      variant="outlined"
      size='small'
      onClick={() => openUnregisteredUserDialog(params)}>
      {t("standard.delete")}
    </SecondaryButton>
  );

  const headers = CreateHeaders([
    booleanHeader("hasActiveOrder", t("standard.activeOrder")),
    booleanHeader("isDeleted", t("standard.deleted")),
    textHeader("email", t("standard.email"), HeaderSizeEnum.EXTRA_LARGE),
    dateHeader("requestDate", t("standard.requestDate")),
    textHeader("nimbusId", "Nimbus ID", HeaderSizeEnum.MEDIUM),
    booleanHeader("existsInNimbus", t("standard.inNimbus")),
    booleanHeader("isBlockedInNimbus", t("standard.blockedInNimbus")),
    booleanHeader("isBlockedInCosmos", t("standard.blockedInCosmos")),
    textHeader("", "", HeaderSizeEnum.MEDIUM, {
      renderer: unregisteredUserRenderer,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
  ])

  return <>
    <WebkuaTable
      headers={headers}
      data={props.unregisteredUsers}
    />
    {/* {unregisteredUser &&
      <UnregisteredUserDialog
        open={!!unregisteredUser}
        onClose={closeUnregisteredUserDialog}
        unregisteredUser={unregisteredUser}
      />
    } */}
  </>;
}

export default UnregisteredUsersGrid;